import { Injectable } from '@angular/core';
import { each, filter, find, includes, reject, without } from 'lodash-es';
import { FloorRenderingService } from './floor-rendering.service';

@Injectable()
export class SelectedComponentsService {
  private selectedComponentFilters: string[] = [];
  private _selectedComponents = [];

  constructor(private floorRenderingService: FloorRenderingService) {
    this.floorRenderingService.onComponentSelect.subscribe(
      this.selectComponent.bind(this)
    );
    this.floorRenderingService.onComponentDeselect.subscribe(
      this.deselectComponent.bind(this)
    );
  }

  get selectedComponents(): any[] {
    return this._selectedComponents;
  }

  addSelectedComponentFilters(...selectedComponentFilters: string[]): void {
    this.selectedComponentFilters.push(...selectedComponentFilters);
  }

  clearSelectedComponentFilters(): void {
    this.selectedComponentFilters = [];
  }

  removeSelectedComponentFilter(name: string): void {
    this.selectedComponentFilters = without(
      this.selectedComponentFilters,
      name
    );
    const componentsToRemove = filter(
      this.selectedComponents,
      (c) => c.name === name
    );
    this._selectedComponents = without(
      this.selectedComponents,
      componentsToRemove
    );
    each(componentsToRemove, (component) => {
      this.deselectComponent(component);
    });
  }

  selectComponent(component: any): void {
    if (
      includes(this.selectedComponentFilters, component.name) &&
      !find(this.selectedComponents, (c) => c.id === component.id)
    ) {
      this.selectedComponents.push(component);
    } else {
      this.deselectComponent(component);
    }
  }

  deselectComponent(component: any): void {
    this._selectedComponents = reject(this.selectedComponents, {
      id: component.id,
    });
    this.floorRenderingService.renderer.deselectComponent(component);
  }

  deselectAll(): void {
    for (const component of this._selectedComponents) {
      this.floorRenderingService.renderer.deselectComponent(component);
    }
    this._selectedComponents = [];
  }
}
